module.exports = __webpack_public_path__ + "img/Hair-Curl.0385f1fc.jpg";